import "./styles.scss";

import CardCreateContacts from "components/card-send-create/card-create-contacts";
import CardCreateSubsectionHeader from "components/card-send-create/card-create-subsection-header";
import { BaIconContactCard } from "components/ui/icons";
import { getFullName } from "components/utils/string";
import { useApp, useFetch, useQueryDict } from "hooks/app";
import { useMember } from "hooks/member";
import { PropTypes } from "prop-types";
import React from "react";
import { ImSpinner8 } from "react-icons/im";
import { bdayFetch } from "services/utils";

const compareNames = (contact, signer) => getFullName(contact.firstName, contact.lastName) === (signer.inviteName || "");

const CardCreateSignerContacts = ({ cardSend, onChange, onErrors, onFinish }) => {
  const { queryDict, search } = useQueryDict();
  const { showAlert, marketing } = useApp();
  const { memberId } = useMember();
  //const [invalidSigners, setInvalidSigners] = useState([]);

  const { contacts, loading, fetchData } = useFetch(memberId ? `/api/1/contacts${search}` : "");

  const { cardSendId, signers } = cardSend;

  const validContacts = contacts?.filter((c) => !!c.email && !c.bounceDttm) || [];
  const inviteSigners = signers?.filter((s) => s.inviteEmail) || [];
  const alreadyInvitedSigners = signers?.filter((s) => s.inviteEmailTrackingId) || [];
  const selectedContacts = validContacts.filter((c) => inviteSigners.find((s) => c.email === s.inviteEmail && compareNames(c, s))) || [];
  const disabledContacts = validContacts.filter((c) => alreadyInvitedSigners.find((s) => c.email === s.inviteEmail && compareNames(c, s))) || [];

  const scraperMarketingId = marketing?.createFlow ? marketing.createFlow.createFlowImportSigners : null;

  const addSigners = async (addedSigners) => {
    const { errors, ...result } = await bdayFetch("/api/1/card/send/signers", { method: "POST", body: { cardSendId, signers: addedSigners, ...queryDict } });
    if (errors?.length > 0) {
      onErrors(errors);
    } else {
      //setInvalidSigners(result.invalidSigners || []);
      onChange(result.cardSend, addedSigners.length);
    }
  };

  const deleteSigners = async (deletedSigners) => {
    const { errors, ...result } = await bdayFetch("/api/1/card/send/signers", {
      method: "DELETE",
      body: { cardSendId, signers: deletedSigners, ...queryDict },
    });
    if (errors?.length > 0) {
      onErrors(errors);
    } else {
      //setInvalidSigners(result.invalidSigners || []);
      onChange(result.cardSend);
    }
  };

  const onSignersChange = async (contacts) => {
    const addedSigners = [];
    const deletedSigners = [];
    contacts?.forEach((c) => {
      const found = signers.find((s) => s.inviteEmail === c.email && compareNames(c, s));
      if (c.checked && !found) {
        addedSigners.push({ inviteEmail: c.email, inviteName: getFullName(c.firstName, c.lastName) });
      } else if (!c.checked && found) {
        deletedSigners.push(found);
      }
    });
    if (addedSigners.length > 0) {
      await addSigners(addedSigners);
    }
    if (deletedSigners.length > 0) {
      await deleteSigners(deletedSigners);
    }
    onFinish();
  };

  const onImportSuccess = () => {
    showAlert({ message: "Your contacts have been imported and should now appear in the list" });
    fetchData();
  };

  return (
    <div className="card-create-signer-contacts-container">
      <CardCreateSubsectionHeader Icon={BaIconContactCard} title="BIRTHDAYALARM CONTACTS" onBack={onFinish} />
      {loading ? (
        <div className="card-create-spinner-wrapper">
          <ImSpinner8 />
        </div>
      ) : (
        <CardCreateContacts
          contacts={validContacts}
          disabledContacts={disabledContacts}
          selectedContacts={selectedContacts}
          disabledMessage={<span className="signer-info">INVITED</span>}
          onChange={onSignersChange}
          onBack={onFinish}
          onImportSuccess={onImportSuccess}
          marketingId={scraperMarketingId}
          contactType="signer"
        />
      )}
    </div>
  );
};

CardCreateSignerContacts.propTypes = {
  cardSend: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onErrors: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
};

CardCreateSignerContacts.defaultProps = {};

export default CardCreateSignerContacts;
